import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { VouchersTable } from 'bundles/backoffice/vouchers/index/table';

export function Voucher({ deal }) {
  return <React.Fragment>
    <h5 className="mb-3">Voucher</h5>
    <div className="table-container">
      <table className="table">
        <VouchersTable minimal vouchers={[{ ...deal.voucher, listing: deal.listing }]} />
      </table>
    </div>
  </React.Fragment>;
}

Voucher.propTypes = {
  deal: PropTypes.shape({
    listing: PropTypes.object,
    voucher: PropTypes.object.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(Voucher);
